module.exports = __webpack_public_path__ + "assets/img/LTC011.dbdfdc0d.png";